// ** React Imports
import { lazy, useEffect, useState } from 'react'

// ** Third Party Components
import classnames from 'classnames'
import { X } from 'react-feather'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { useJunctions } from '../../../hooks/useQuery/useJunctions'

// ** Reactstrap Imports

// ** Styles
import '@styles/react/libs/react-select/_react-select.scss'
import { FA } from '../../../common/Icons'
import useJunctionId from '../../../hooks/useJunctionId'
const Area = lazy(() => import('./Area'))

const Customizer = () => {
  const { junctionId } = useJunctionId()

  const { isLoading: junctionLoading, data: junctions } = useJunctions()

  // ** State
  const [openCustomizer, setOpenCustomizer] = useState(false)

  // ** Toggles Customizer
  const handleToggle = (e) => {
    if (e) {
      e.preventDefault()
    }
    setOpenCustomizer(!openCustomizer)
  }

  useEffect(() => {
    if (junctionId === undefined) {
      setOpenCustomizer(!openCustomizer)
    }
  }, [])

  if (junctionLoading) {
    return <div>Loading</div>
  }

  return (
    <div
      className={classnames('customizer', {
        open: openCustomizer,
      })}
    >
      <a
        href='/'
        className='customizer-toggle d-flex align-items-center justify-content-center'
        onClick={handleToggle}
      >
        <FA.FaTrafficLight size={14} />
      </a>
      <PerfectScrollbar
        className='customizer-content'
        options={{ wheelPropagation: false }}
      >
        <div className='customizer-header px-2 pt-1 pb-0 position-relative'>
          <h4 className='mb-0'>Junction Selection</h4>
          <a href='/' className='customizer-close' onClick={handleToggle}>
            <X />
          </a>
        </div>
        <hr />

        {junctions ? (
          <div className='mt-1'>
            <Area
              areas={junctions.result}
              junctionId={junctionId}
              handleToggle={handleToggle}
            />
          </div>
        ) : null}
      </PerfectScrollbar>
    </div>
  )
}

export default Customizer
